// Hook for debouncing component state values.
// Source: https://usehooks-ts.com/react-hook/use-debounce (MIT Licence)

import { useEffect, useState } from 'react';

/**
 * Use to update state following another state but with a debounced timing
 * @param delay - The delay in milliseconds
 */
function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
